import React, {ReactElement} from 'react';
import styles from './styles.module.scss';
import classnames from 'classnames';
import 'stylesheets/components/nav-bar-invite-list.scss';
import EmojiPeople from './EmojiPeople';
import EarnedReferralSection from '../student-referral-modal/earned-referral-section';
import {Link, useLocation} from 'react-router-dom';
import PlatformService from '../../services/PlatformService';

interface MobileInvitesProps {
  awardAmount: number;
}

const MobileInvitations = ({awardAmount}: MobileInvitesProps): ReactElement => {
  let policyLink: string;

  if (awardAmount !== 50) {
    policyLink =
      'https://help.raise.me/hc/en-us/articles/115002094908-Student-Referrals-Give-100-Get-100';
  } else {
    policyLink =
      'https://help.raise.me/hc/en-us/articles/360015748693-Student-Referrals-Give-50-Get-50';
  }

  const location = useLocation();

  return (
    <div className={styles.friendDiv}>
      <EmojiPeople />
      <EarnedReferralSection awardAmount={awardAmount} />
      <div className={classnames(styles.centerText, styles.paddingTop)}>
        <span>
          Get a ${awardAmount} micro-scholarship from participating colleges when your friends sign
          up. Learn more about the&nbsp;
        </span>
        <span>
          <a
            href={policyLink}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Learn more (opens in new tab)"
          >
            Referral Program Policy.
          </a>
        </span>
      </div>
      <div className={classnames(styles.centerContent, styles.paddingTop, styles.paddingBottom)}>
        <Link
          to={PlatformService.isNativeApp() ? '/invitations' : `${location.pathname}/invite/create`}
          key="openStudentReferralPage"
          className="shared-button medium blue btn-margin-top"
        >
          Invite Friends
        </Link>
      </div>
    </div>
  );
};

export default MobileInvitations;
